import { DocumentItemList } from '../../components/document/DocumentItemList';
import { useFetchDriverDocuments } from '../../hooks/useFetchDriverDocuments';

type Props = {
  driverKey: string;
};

export const DriverDocuments = ({ driverKey }: Props) => {
  const { data, isLoading } = useFetchDriverDocuments(driverKey);

  return <DocumentItemList isLoading={isLoading} documentItems={data?.items} driverKey={driverKey} />;
};
